<template>
    <el-dialog class="el-dialogs" :title="title" width="500px" :close-on-click-modal="false" :visible.sync="visible">
        <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules"
                 @keyup.enter.native="doSubmit()" @submit.native.prevent
                 :disabled="title == '查看连接池'"
                 label-width="110px">
            <el-form-item label="选择数据库：" prop="connectionDatabase">
                <el-select style="width: 100%" v-model="searchForm.connectionDatabase"
                           clearable
                           placeholder="请选择数据库">
                    <el-option
                            v-for="item in $dictUtils.getDictList('connection_database')"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="标题：" prop="connectionTitle">
                <el-input v-model.trim="searchForm.connectionTitle" maxlength="20"
                          placeholder="请输入标题(限20字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item label="描述：" prop="connectionDescription">
                <el-input v-model.trim="searchForm.connectionDescription" maxlength="500"
                          placeholder="请输入描述(限500字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item label="驱动类名：" prop="connectionDrive">
                <el-input v-model.trim="searchForm.connectionDrive" maxlength="100"
                          placeholder="请输入驱动类名(限100字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item label="链接地址：" prop="connectionAddress">
                <el-input
                        type="textarea"
                        placeholder="请输入链接地址(限500字)"
                        v-model="searchForm.connectionAddress"
                        maxlength="500"
                        rows="5" resize="none"
                ></el-input>
            </el-form-item>
            <el-form-item label="用户名：" prop="userName">
                <el-input v-model.trim="searchForm.userName" maxlength="50"
                          placeholder="请输入用户名(限50字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item label="密码：" prop="userPassword">
                <el-input v-model.trim="searchForm.userPassword" maxlength="50"
                          placeholder="请输入密码(限50字)" show-password
                ></el-input>
            </el-form-item>

            <el-form-item label="执行周期：" prop="connectionCron" class="itemInput">
                <div class="flex_b_c">
                    <el-input v-model.trim="searchForm.connectionCron" maxlength="50"
                              placeholder="请输入执行周期(限50字)" style="margin-right: 10px"
                              clearable></el-input>
                    <el-popover
                        placement="top-start"
                        width="600"
                        trigger="hover">
                        <div style="white-space: pre-wrap;">
                            Cron表达式是一个由6个子表达式组成的字符串。每个子表达式都描述了一个单独的日程细节。
                            这些子表达式用空格分隔，分别表示：<br>
                            秒（0~59）<br>
                            分钟（0~59）<br>
                            小时（0~23）<br>
                            天（月）（1~31，取决于月份）<br>
                            月（1~12）<br>
                            天（星期）（可使用数字或英文缩写，如1或者MON,其中0和7都代表星期天（SUN））<br>
                            其中每个元素可以是一个值（如6）,一个连续区间（9-12）,一个间隔时间（8-18/4）
                            （表示8-18中每隔4（分钟、小时......取决于子表达式））,一个列表（1,3,5）,通配符。<br>
                            由于"月份中的日期"和"星期中的日期"这两个子表达式是互斥的,必须要对其中一个设置"?".<br>
                            cron表达式举例：<br>
                            0 0 10,14,16 * * ? 每天上午10点，下午2点，4点<br>
                            0 0/30 9-17 * * ? 朝九晚五工作时间内每半小时<br>
                            0 0 12 ? * WED 表示每个星期三中午12点<br>
                            0 0 12 * * ? 每天中午12点触发<br>
                            0 15 10 ? * * 每天上午10:15触发<br>
                            0 15 10 * * ? 每天上午10:15触发<br>
                            0 * 14 * * ? 在每天下午2点到下午2:59期间的每1分钟触发<br>
                            0 0/5 14 * * ? 在每天下午2点到下午2:55期间的每5分钟触发<br>
                        </div>
                        <div slot="reference" class="iconPrompt el-icon-question"></div>
                    </el-popover>
                </div>
            </el-form-item>
            <el-form-item label="同步数据值：" prop="synchronizationType">
                <el-select style="width: 100%" v-model="searchForm.synchronizationType"
                           placeholder="请选择同步数据值">
                    <el-option
                            v-for="item in dataValueList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div v-if="title != '查看连接池'" class="flex_b_c" slot="footer">
            <el-button size="small" type="primary" @click="connect()" v-noMoreClick>测试连接</el-button>
            <div>
                <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>提交</el-button>
                <el-button size="small" @click="visible = false">取消</el-button>
            </div>
        </div>
        <div v-else slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { isValidCron } from 'cron-validator'
export default {
    name: "connectAdd",
    data() {
        var verifyExpression = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入cron表达式'));
            } else {
                if (!isValidCron(value)) {
                    callback(new Error('请输入正确的cron表达式'));
                } else {
                    callback();
                }
            }
        };
        return {
            title: '新建连接池',
            visible: false,
            searchForm: {
                id:'',
                connectionDatabase: '',
                connectionTitle: '',
                connectionDescription: '',
                connectionDrive: '',
                connectionAddress: '',
                userName: '',
                userPassword: '',
                connectionCron: '',
                synchronizationType: '',
            },
            rules: {
                connectionDatabase: [
                    {required: true, message: '选择数据库', trigger: 'change'}
                ],
                connectionTitle: [
                    {required: true, message: '请输入标题', trigger: 'blur'}
                ],
                connectionDrive: [
                    {required: true, message: '请输入驱动类名', trigger: 'blur'}
                ],
                connectionAddress: [
                    {required: true, message: '请输入链接地址', trigger: 'blur'}
                ],
                connectionCron: [
                    {validator: verifyExpression, trigger: 'blur'},
                    {required: true, message: '请输入cron表达式', trigger: 'blur'}
                ],
                synchronizationType: [
                    {required: true, message: '请选择同步数据值', trigger: 'change'}
                ],
            },
            dataValueList: [
                {
                    label:'全部同步',
                    value:'0',
                },
                {
                    label:'增量同步',
                    value:'1',
                },
            ],
        }
    },

    methods: {
        //typeName see查看 edit编辑 add新增
        init(typeName, row) {
            this.visible = true
            this.searchForm.id = ''
            this.$nextTick(() => {
                this.$refs.searchForm.resetFields();
            })
            if (typeName == 'add') {
                this.title = '新建连接池'
            }
            if (typeName == 'see') {
                this.title = '查看连接池'
                this.$axios(this.api.academic.connectionpoolGetById + row.id).then(data => {
                    if (data && data.status) {
                        Object.keys(this.searchForm).forEach(key=>{
                            this.searchForm[key] = data.data[key]
                        })
                    }
                })
            }
        },

        changeCycle() {
            if (this.searchForm.cycle != 1) {
                this.$refs.searchForm.validateField('month');
                this.searchForm.month = ''
            }
            if (this.searchForm.cycle == 3 || this.searchForm.cycle == 4) {
                this.$refs.searchForm.validateField('executionDate');
                this.searchForm.executionDate = ''
            }
            if (this.searchForm.cycle == 4) {
                this.$refs.searchForm.validateField('weeklyExecution');
                this.searchForm.weeklyExecution = ''
            }
        },

        //测试连接
        connect() {
            // this.$refs.searchForm.validate((valid) => {
            //     if (valid) {
                    let msaage = this.$message({
                        message:'检测中……',
                        duration:0,
                    });

                    setTimeout(()=>{
                        msaage.close()
                        this.$message.success('检测成功')
                    },2000)
            //     }
            // })
        },

        //提交
        doSubmit() {
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    if (this.searchForm.id) {
                        this.$axios(this.api.academic.academicresourcesUpdateById, this.searchForm, 'put').then(data => {
                            if (data && data.status) {
                                this.$message.success('修改成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        this.$axios(this.api.academic.connectionpoolSave, this.searchForm, 'post').then(data => {
                            if (data && data.status) {
                                this.$message.success('保存成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            });
        },
    },
}
</script>

<style scoped>
.el-dialogs >>> .el-dialog__body {
    height: auto !important;
}

.magTop {
    margin-top: 10px;
}

.variation {
    flex-wrap: wrap;
    position: relative;

    .el-form-item {
        width: 49%;
    }

    .iconPrompt {
        position: absolute;
        right: -40px;
        bottom: 24px;
        font-size: 22px;
        width: 22px;
        height: 22px;
    }
}
</style>